module.exports = __webpack_public_path__ + "static/media/다.700121d9.jpg";